// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"51":"NewsList","471":"activity","549":"ArticleDetails","664":"notice","732":"News","969":"More"}[chunkId] || chunkId) + "." + {"51":"9b8149c2","471":"4f034e44","549":"c9ffd874","574":"f7c427f0","664":"4f034e44","732":"4f034e44","969":"72dfd7fe"}[chunkId] + ".css";
};